/**
 * Carrega cidades da API quando o campo UF (state) muda.
 * Aceita parâmetro q para busca sem acentos (julio = júlio).
 * Uso: types.observer('billing_address_state'), types.obs_load_cities() e types.obs_filter_cities(stateField).
 */
import { loadOptions } from '../../versa/formset.js';
import api from '../api.js';

const CITIES_CACHE = {};

function fetchCities(uf, q) {
	const u = String(uf || '').trim().toUpperCase().slice(0, 2);
	if (!u || u.length < 2) return Promise.resolve([]);
	let query = `?filter=state*eq*${encodeURIComponent(u)}&limit=500`;
	if (q && String(q).trim()) query += `&q=${encodeURIComponent(String(q).trim())}`;
	return api.call(api.list_cities, query).then(d => Array.isArray(d) ? d : []);
}

export default function ()
{
	const SHARED = { _this: null };

	return {
		async actions(ev, publisher, state)
		{
			const action = async (uf) =>
			{
				const u = String(uf || '').trim().toUpperCase().slice(0, 2);
				if (!u || u.length < 2) {
					loadOptions(this.selector, [], 'id', ['city']);
					this.refresh?.();
					return;
				}
				const data = await fetchCities(u, '');
				loadOptions(this.selector, data, 'id', ['city']);
				this.refresh?.();
			};
			const uf = String(state ?? '').trim().toUpperCase().slice(0, 2);
			if (uf.length >= 2)
				this.preventMultiCalls(SHARED, action, () => this.refresh?.(), uf);
			else
				action(uf);
		}
	};
}

export { fetchCities };
